exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-select[data-v-2d3abe28] {\n  width: 100%;\n}\n", ""]);

// exports
